// src/App.js

import React from 'react';
import CardGroups from './Design/CardGroups';
import './Design.css';

function Design() {
  return (
    <div className="Design">
        <CardGroups/>
    </div>
  );
}

export default Design;